export default __webpack_public_path__ + "static/ANALOGMANTRA-734f5ddb60ae5776ea42f3b7f187dd3d.svg";